import { BaseInput, Ptag } from "components/core";
import { TpaDetailInputWrapper } from "components/Flex/styles";
import React, { useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

const RoomLimit = ({ formikProps }) => {
  const [referedDefault, setDefault] = useState(false)
  const handleChange = () => {
    setDefault(prevVal => !prevVal)
    formikProps.setFieldValue('customized_room_limit', null)
    formikProps.setFieldValue("metro_normal", "");
    formikProps.setFieldValue('metro_icu', "");
    formikProps.setFieldValue("non_metro_normal", "");
    formikProps.setFieldValue('non_metro_icu', "");
  }
  return (
    <div style={{ marginBottom: "4rem" }}>
      <FormControlLabel
        required
        control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }} onChange={()=>handleChange()}/>}
        label={
          <Ptag fontSize='16px' fontWeight='600'>Please Refer Policy Document</Ptag>
        }
      />
      <Ptag fontSize="14px" marginTop="10px" fontWeight="700">
        {"Metro Cities"}
      </Ptag>
      <TpaDetailInputWrapper marginTop="0rem">
        <div>
          <BaseInput
            formatToRupee
            disabled={referedDefault}
            label="Normal Room Limit"
            fontSize="16px !imortant"
            variant="standard"
            formikProps={{
              ...formikProps,
              name: "metro_normal",
            }}
          />
        </div>
        <div>
          <BaseInput
            formatToRupee
            disabled={referedDefault}
            label="ICU Limit"
            fontSize="16px !imortant"
            variant="standard"
            formikProps={{
              ...formikProps,
              name: "metro_icu",
            }}
          />
        </div>
      </TpaDetailInputWrapper>
      <Ptag fontSize="14px"  marginTop="10px" fontWeight="700">
        {"Non-Metro Cities"}
      </Ptag>
      <TpaDetailInputWrapper>
        <div>
          <BaseInput
            formatToRupee
            disabled={referedDefault}
            label="Normal Room Limit"
            fontSize="16px !imortant"
            variant="standard"
            formikProps={{
              ...formikProps,
              name: "non_metro_normal",
            }}
          />
        </div>
        <div>
          <BaseInput
            formatToRupee
            disabled={referedDefault}
            label="ICU Limit"
            fontSize="16px !imortant"
            variant="standard"
            formikProps={{
              ...formikProps,
              name: "non_metro_icu",
            }}
          />
        </div>
      </TpaDetailInputWrapper>
    </div>
  );
};

export default RoomLimit;
